import getRootModule from './root.module'

export default getRootModule
